import ClientLayout from "@/layouts/client-layout/ClientLayout.vue";

export default (router) => {
  router.addRoute({
    path: "/event",
    redirect: "/event",
    component: ClientLayout,
    name: "event",
    children: [
      {
        path: "/event",
        name: "Event",
        component: () =>
          import(/*webpackChunkName:'event'*/ "./views/EventIndex.vue"),
        meta: {
          pageTitle: "title.event",
          breadcrumbs: ["title.event"],
          permissions: ["TenantAdmin"],
          tenantPermissions: ["bvi", "sea", "bbl"],
        },
      },
    ],
  });
};
